const semanticClassNames = {
  root: 'vertical-line',
} as const;

export default semanticClassNames;
